"use client";

import dynamic from "next/dynamic";

const TestimonialsLoader = dynamic(() => import("./Testimonials"), {
  ssr: false,
});

export default function TestimonialsWrapper({ cmsData }: { cmsData?: any }) {
  return <TestimonialsLoader cmsData={cmsData} />;
}
